import { render, staticRenderFns } from "./MatchSummary.vue?vue&type=template&id=51f853e2&"
import script from "./MatchSummary.vue?vue&type=script&lang=js&"
export * from "./MatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./MatchSummary.vue?vue&type=style&index=0&id=51f853e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports